<template>
  <div class="text-xs-center">
    <v-menu
      v-model="menu"
      max-width="640"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      lazy
    >
      <template #activator="{ on }">
        <v-btn flat icon v-on="on">
          <v-badge color="red" overlap>
            <span v-if="filtersCount" slot="badge">{{ filtersCount }}</span>
            <v-icon>tune</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-card>
        <v-layout wrap row pa-3>
          <v-flex xs12 px-2>
            <category-menu
              v-model="localFilters.categoryId"
              clearable
              :label="$tc('models.category')"
            />
          </v-flex>

          <v-flex xs12 px-2>
            <entity-field
              v-model="localFilters.entityId"
              :label="$tc('models.entity')"
              filter-data
              @update:teams="handleTeamsUpdate"
            />
          </v-flex>

          <v-flex xs12 px-2>
            <team-field
              v-model="localFilters.teamId"
              :entity-id="localFilters.entityId"
              :category-id="localFilters.categoryId"
              :label="$tc('models.team')"
            />
          </v-flex>
          <!-- Filtro Campo -->
          <v-flex xs12 px-3>
            <pitch-field
              v-model="localFilters.location"
              :entity-id="localFilters.entityId"
              :team-id="localFilters.teamId"
              :label="$t('fields.global.location')"
            />
          </v-flex>

          <!-- Filtro fechas -->
          <v-flex xs12>
            <v-layout wrap row>
              <v-flex xs12 md6 px-2>
                <date-picker
                  v-model="localFilters.dateStart"
                  :label="$t('fields.tournaments.startAt')"
                />
              </v-flex>

              <v-flex xs12 md6 px-2>
                <date-picker
                  v-model="localFilters.dateEnd"
                  :label="$t('fields.tournaments.endAt')"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider />
        <v-card-actions>
          <v-spacer />

          <v-btn
            color="primary"
            flat
            :loading="$store.state.trainings.loading"
            @click="search"
          >
            {{ $t('action.buttons.search') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import CategoryMenu from '@/components/management/categories/CategoryMenu'
import DatePicker from '@/components/widgets/Input/DatePicker'
import EntityField from '@/components/widgets/Input/EntityField'
import PitchField from '@/components/widgets/Input/PitchField'
import TeamField from '@/components/widgets/Input/TeamField'

export default {
  name: 'TrainingFilters',
  components: {
    CategoryMenu,
    TeamField,
    EntityField,
    PitchField,
    DatePicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data: () => ({
    menu: false,
  }),

  computed: {
    localFilters: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    filtersCount() {
      let count = 0
      Object.keys(this.localFilters || {}).forEach((key) => {
        if (
          key != 'match' &&
          this.localFilters[key] &&
          this.localFilters[key].length
        ) {
          count++
        }
      })
      return count
    },
  },
  methods: {
    handleTeamsUpdate() {
      this.localFilters.teamId = ''
    },
    search() {
      this.menu = false
      this.$emit('search')
    },
  },
}
</script>
